import React from "react";
import { apolloClient } from "data/graphql";
import { CreateSubDoc, CreateSubDocVariables } from "types/gql-types";
import completeDocument from "pages/eligibility/query/complete-document.gql";
import createDocument from "pages/eligibility/query/create-document.gql";

type Document = {
  id: string;
}

export type UploadType = (file: File) => Promise<Document>;

export const createUploadContext = (submissionId: string): UploadType => async (file: File) => {
  const request = await apolloClient.mutate<CreateSubDoc, CreateSubDocVariables>({
    mutation: createDocument,
    variables: {
      submissionId,
      document: {
        filename: file.name,
        size: file.size,
      },
    },
  });

  if (!request.data) {
    throw new Error("Failed to submit file");
  }

  const { createSubmissionDocument: preflight } = request.data;
  await fetch(preflight.uploadUrl, {
    method: "PUT",
    body: file,
  });

  await apolloClient.mutate({
    mutation: completeDocument,
    variables: {
      documents: [preflight.document.id],
    },
  });

  return preflight.document;
};

// eslint-disable-next-line require-await
export default React.createContext<UploadType>(async () => ({ id: "" }));
